var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85158 0.00734711C4.42739 0.189466 4.29377 2.6247 2.56314 2.51716C1.01521 2.42098 0.989633 0.179893 2.48366 0.00734711C2.56867 -0.00244904 2.76634 -0.00244904 2.85158 0.00734711Z",
    fill: "#26445A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28837 5.51347L0.930818 6.46704C0.73223 6.71305 -0.00867756 6.75446 7.6935e-05 6.34726L1.08748 3.06622C1.17088 2.89857 1.34412 2.81753 1.52866 2.80395C2.27717 2.7494 3.09571 2.84669 3.8516 2.80484C4.26329 2.85404 4.30568 3.23475 4.41534 3.54823C4.70769 4.38424 5.06709 5.34092 5.29448 6.18495C5.32673 6.30451 5.35967 6.36774 5.30001 6.49064C5.18343 6.73064 4.55887 6.683 4.40451 6.46704L4.04696 5.51347V10.1206C4.04696 10.1593 3.98959 10.31 3.96725 10.3545C3.69793 10.8958 2.7824 10.6841 2.7824 10.0985V7.06794H2.55247V10.0985C2.55247 10.3024 2.38015 10.5324 2.19008 10.6144C1.81364 10.7764 1.28814 10.5364 1.28814 10.1208V5.51369L1.28837 5.51347Z",
    fill: "#26445A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3531_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18483 0.00734711C9.76064 0.189466 9.62702 2.6247 7.89639 2.51716C6.34846 2.42098 6.32289 0.179893 7.81691 0.00734711C7.90192 -0.00244904 8.09959 -0.00244904 8.18483 0.00734711Z",
    fill: "#26445A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62162 5.51347L6.26407 6.46704C6.06548 6.71305 5.32457 6.75446 5.33333 6.34726L6.42073 3.06622C6.50413 2.89857 6.67738 2.81753 6.86191 2.80395C7.61042 2.7494 8.42897 2.84669 9.18485 2.80484C9.59654 2.85404 9.63893 3.23475 9.74859 3.54823C10.0409 4.38424 10.4003 5.34092 10.6277 6.18495C10.66 6.30451 10.6929 6.36774 10.6333 6.49064C10.5167 6.73064 9.89212 6.683 9.73776 6.46704L9.38021 5.51347V10.1206C9.38021 10.1593 9.32285 10.31 9.3005 10.3545C9.03118 10.8958 8.11565 10.6841 8.11565 10.0985V7.06794H7.88573V10.0985C7.88573 10.3024 7.7134 10.5324 7.52334 10.6144C7.14689 10.7764 6.62139 10.5364 6.62139 10.1208V5.51369L6.62162 5.51347Z",
    fill: "#26445A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3531_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5183 0.00734711C15.0941 0.189466 14.9605 2.6247 13.2299 2.51716C11.682 2.42098 11.6564 0.179893 13.1504 0.00734711C13.2354 -0.00244904 13.4331 -0.00244904 13.5183 0.00734711Z",
    fill: "#26445A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9551 5.51347L11.5976 6.46704C11.399 6.71305 10.6581 6.75446 10.6668 6.34726L11.7542 3.06622C11.8376 2.89857 12.0109 2.81753 12.1954 2.80395C12.9439 2.7494 13.7625 2.84669 14.5183 2.80484C14.93 2.85404 14.9724 3.23475 15.0821 3.54823C15.3744 4.38424 15.7338 5.34092 15.9612 6.18495C15.9935 6.30451 16.0264 6.36774 15.9668 6.49064C15.8502 6.73064 15.2256 6.683 15.0713 6.46704L14.7137 5.51347V10.1206C14.7137 10.1593 14.6563 10.31 14.634 10.3545C14.3647 10.8958 13.4491 10.6841 13.4491 10.0985V7.06794H13.2192V10.0985C13.2192 10.3024 13.0469 10.5324 12.8568 10.6144C12.4804 10.7764 11.9549 10.5364 11.9549 10.1208V5.51369L11.9551 5.51347Z",
    fill: "#26445A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.33333,
    height: 10.6667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3531_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.33333,
    height: 10.6667,
    fill: "white",
    transform: "translate(5.33325)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3531_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.33333,
    height: 10.6667,
    fill: "white",
    transform: "translate(10.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/Children.1867fdfe4ee060928e6fcdec0d0690b0.svg";
export { ForwardRef as ReactComponent };